import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer} from '@angular/forms';
import { Filter } from '../../../../models/filter.models';
import { SelectService } from './select.service';


@Component({
  selector: 'select-filter',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit {
  public selectFormGroup :any ;
  private queryParam : any;
  public list : any[] = [];
  constructor(
    public controlContainer: ControlContainer,
    public selectService : SelectService
  ) {
  }

  @Input() data: Filter;

  ngOnInit(): void {
    this.selectFormGroup = this.controlContainer.control
    this.queryParam = this.data.options.query_params;
    if (this.data.options.is_api) {
      this.search('');
    } else {
      this.list = this.data.options.data;
    }
  }


  search( search : string)
  {
    let params = this.queryParam ? {...this.queryParam , ...{search: search ,isPaginate : false}} : { search: search ,isPaginate : false};
    this.selectService.get(this.data.options.end_point, params)
      .subscribe(data => {
      this.list = data;
    });
  }


}
